import { clsx } from 'clsx';
import { cva } from 'class-variance-authority';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from '../Input.module.css';

export const inputLabelVariantOptions = ['default', 'error'] as const;
export type InputLabelVariant = (typeof inputLabelVariantOptions)[number];

export type InputLabelProps = ComponentPropsWithRef<'label'> & {
  className?: string;
  children?: ReactNode;
  htmlFor: string;
  isFloating?: boolean;
  variant?: InputLabelVariant;
};

export const inputLabelVariants = cva(s.label, {
  variants: {
    variant: {
      default: s.defaultVariant,
      error: s.errorVariant,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const InputLabel = (props: InputLabelProps) => {
  const {
    children,
    className,
    htmlFor,
    isFloating = true,
    variant = 'default',
    ...attrs
  } = props;

  return (
    <label
      data-is-floating={isFloating}
      htmlFor={htmlFor}
      className={clsx(
        inputLabelVariants({
          variant,
        }),
        className,
      )}
      {...attrs}
    >
      {children}
    </label>
  );
};
